import dayjs from "dayjs";

const MinDay = 10;

export function completeDateArray(dateArray: string[]) {
  const dayjsArray = dateArray.map((date) => dayjs(date));

  if (dateArray.length === 0) {
    return [];
  }

  if (dayjsArray.length >= MinDay) return dateArray;

  const daysToAdd = MinDay - dayjsArray.length;
  const daysToAddLeft = Math.floor(daysToAdd / 2);
  const daysToAddRight = daysToAdd - daysToAddLeft;

  for (let i = 0; i < daysToAddLeft; i++) {
    const newDate = dayjsArray[0].subtract(1 + i, "day").format("YYYY-MM-DD");
    dayjsArray.unshift(dayjs(newDate));
  }

  for (let i = 0; i < daysToAddRight; i++) {
    const newDate = dayjsArray[dayjsArray.length - 1].add(1 + i, "day").format("YYYY-MM-DD");
    dayjsArray.push(dayjs(newDate));
  }

  return dayjsArray.map((dayjsObj) => dayjsObj.format("YYYY-MM-DD"));
}
